import { HoursOfOperation } from 'components/types/LocationTypes';

export const isClinicOpen = (hours?: string): boolean => {
    if (!hours) return true;
    try {
        const jsonHours: Array<HoursOfOperation> = JSON.parse(hours);
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const now = new Date();
        const currentDay = days[now.getDay()];
        const currentTime = now.toTimeString().slice(0, 5);

        const todayHours = jsonHours.find(h => h.openDay.toLowerCase() === currentDay);
        if (!todayHours) return false;

        const formatTime = (time: string) => {
            const [h, m] = time.split(':');
            return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
        };

        const open24 = parseInt(todayHours.closeTime) - parseInt(todayHours.openTime) === 24;
        if (open24) return true;

        return currentTime >= formatTime(todayHours.openTime) && currentTime < formatTime(todayHours.closeTime);
    } catch {
        return false;
    }
};